import { formatPower } from "in_queue/utils/formatting";
import { TextLinkButton } from "../common/TextLinkButton";
import tableCss from "./TableStyles.module.scss";

/**
 * Show the share of the queue's ERIS MW that a scenario's sensitivities
 * remove. With `link`, the share is a link-styled button.
 */
export const SensitivitiesSummary: React.FC<{
    readonly mwRemoved: number;
    readonly clusterMw: number;
    readonly link?: {
        readonly onClick: () => void;
        readonly ariaLabel: string;
    };
}> = ({ mwRemoved, clusterMw, link }) => {
    const percentageMwRemoved = mwRemoved / clusterMw;
    const share = `Adjusts ${(percentageMwRemoved * 100).toFixed(1)}% of queue`;
    return (
        <div className={tableCss["two-line-cell"]}>
            {link === undefined ? (
                <span>{share}</span>
            ) : (
                <TextLinkButton
                    text={share}
                    onClick={link.onClick}
                    ariaLabel={link.ariaLabel}
                />
            )}
            <span className={tableCss["muted-cell"]}>
                {formatPower(mwRemoved)} of {formatPower(clusterMw)}
            </span>
        </div>
    );
};
